import { MENU_JIAMENG_SETTING, SELLERSERVICE_PATH } from '@constant'

export default {
  key: MENU_JIAMENG_SETTING,
  id: '',
  title: '设置',
  icon: 'icon-shezhi',
  link: SELLERSERVICE_PATH
}
